import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedForRate } from '../actions/BehaviourDataActions'

class TimerForRate extends Component {

    componentDidMount = () => {
        this.props.newIncrementer.map((obj, index) => {
            return clearInterval(this.props.newIncrementer[0]);
        })
        if (this.props.isStart) {
            this.props.customSecondsElapsedForRate("mount")
        }
    }

    getSeconds = () => {
        return ('0' + this.props.secondsElapsed % 60).slice(-2)
    }

    getMinutes = () => {
        return Math.floor(this.props.secondsElapsed / 60)
    }

    componentWillUnmount = () => {
        this.props.incrementer.map((obj, index) => {
            return clearInterval(this.props.incrementer[0]);
        })
        this.props.customSecondsElapsedForRate("unmount")
    }

    render() {
        return (
            <div>
                {this.getMinutes()}:{this.getSeconds()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStart: state.patientRecordRateCustomReducer.isStart,
        secondsElapsed: state.patientRecordRateCustomReducer.secondsElapsed,
        incrementer: state.patientRecordRateCustomReducer.incrementer,
        newIncrementer: state.patientRecordRateCustomReducer.newIncrementer
    }
}

export default connect(mapStateToProps, {customSecondsElapsedForRate})(TimerForRate);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/TimerForRate.js